import axios from 'axios';

const getContext = () => axios.get('/empresas/context');
const create = (user) => axios.post('/empresas', user);
const update = (id, user) => axios.put(`/empresas/${id}`, user);
const save = (user) => {
  if (user.id) {
    return update(user.id, user);
  }
  return create(user);
};

export default {
  getContext,
  create,
  update,
  save,
};
